<template>
    <div class="quote-container">
        <div class="primary-content">
            <div class="quote left">
                <!-- Use v-html so webpack doesn't mangle the special characters -->
                <div v-html="'&ldquo;'" />
            </div>
            <div class="quote-content">
                <div
                    class="inline-block"
                    v-html="quote.content"
                />
            </div>
            <div class="quote right">
                <!-- Use v-html so webpack doesn't mangle the special characters -->
                <div v-html="'&rdquo;'" />
            </div>
        </div>
        <a
            v-if="quote.attribution"
            class="quote-attribution"
            :href="quote.link"
            target="_blank"
        >
            - {{ quote.attribution }}
        </a>
    </div>
</template>

<script>

export default {
    props: {
        quote: Object
    }
};
</script>

<style src="./common.container.css" scoped></style>
<style lang="postcss" scoped>

.primary-content {
    @apply flex flex-row justify-around items-baseline;
}

.quote-content {
    @apply flex-grow pl-1 leading-snug font-normal;
}

.quote-attribution, .quote-attribution:hover {
    @apply w-full text-right block uppercase font-bold text-xs text-neutral-text;
    /* margin-top: -1rem; */
    padding-top: 8px;
}

.quote-attribution:hover {
    @apply underline;
}


.quote-container {
    @apply mb-4;
}
.quote {
    @apply flex-grow-0 leading-normal;
    /* The quotes are quite big, but we don't want to take up any space in the document flow */
    height: 0;
}

.quote.left {
    align-self: flex-start;
}
.quote.right {
    align-self: flex-end;
}

/* Empirically chosen to get quotes to align properly */
.quote.left div {
    margin-top: -100%;
}
.quote.right div {
    margin-top: -200%;
}

/* @screen sm { */
    .quote-content{ @apply text-lg; }
    .quote { font-size: 75px; }
    a.quote-attribution { padding-left: 26px; }
/* } */
@screen md {
    .quote-content{ font-size: 22px; }
    .quote { font-size: 90px; }
    a.quote-attribution { padding-left: 32px; }
}
@screen lg {
    .quote-content{ @apply text-xl; }
    .quote { font-size: 100px; }
    a.quote-attribution { padding-left: 36px; }
}
</style>
